import React, { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/attendance/AttendanceAction";
import {
  ExportButton,
  copySectionAttendances,
  exportSectionAttendancesToExcel,
  exportSectionAttendancesToPDF,
  getAuthorities,
  getDateFormat,
  print,
} from "../../../../../../_helpers/Helpers";
import {
  Card, 
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { SectionsFilter } from "./sections-filter/SectionsFilter";
import { SectionsTable } from "./sections-table/SectionsTable";
import { useSectionsUIContext } from "./SectionsUIContext";

export function SectionsCard({
  date
}) {
  // Sections Card UI Context
  const sectionsUIContext = useSectionsUIContext();
  const sectionsUIProps = useMemo(() => {
    return {
      queryParams: sectionsUIContext.queryParams
    };
  }, [sectionsUIContext]);

  // Getting curret state of Sections from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.attendance }),
    shallowEqual
  );  
  const { dailyCourseHour, authorities } = currentState;

  // Authority Parameters
  const { isExportationAuthorized } = getAuthorities(authorities);

  // Students Redux state
  const dispatch = useDispatch();

  /** Belli Bir Sınıf Listesine Ait Yoklama Listesini Excele Aktarır */
  const exportToExcel = () => {
    dispatch(actions.getAllSectionAttendances(sectionsUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const widths = [30];
      const columns = ["Sınıf"];

      for (let i = 0; i < dailyCourseHour; i++) {
        widths.push(20);
        columns.push((i + 1) + ". Ders");
      }

      entities.forEach(entity => {
        const row = [entity.section];
        for (let i = 0; i < dailyCourseHour; i++) row.push(entity.attendanceStatuses[i]);
        rows.push(row);
      });

      const filename = getDateFormat(date) + " Tarihli Sınıf Yoklama Listesi";
      const sheetname = "Yoklama Listesi"
      exportSectionAttendancesToExcel({ columns, rows, widths, filename, sheetname });
    });
  }

  /** Belli Bir Sınıf Listesine Ait Yoklama Listesini PDF e Aktarır */
  const exportToPDF = () => {
    dispatch(actions.getAllSectionAttendances(sectionsUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const views = [ 
        {
          header: "Sınıf",
          rows: entities.map(entity => entity.section)
        }
      ];

      for (let i = 0; i < dailyCourseHour; i++) {
        const view = {
          header: (i + 1) + ". Ders",
          rows: entities.map(entity => entity.attendanceStatuses[i])
        };
        views.push(view);
      }

      const filename = getDateFormat(date) + " Tarihli Sınıf Yoklama Listesi";
      exportSectionAttendancesToPDF(views, filename);
    });
  }

  /** Belli Bir Sınıf Listesine Ait Yoklama Listesini Yazdırma Penceresini Açar */
  const printSectionAttendances = () => {
    dispatch(actions.getAllSectionAttendances(sectionsUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const data = [];
      const header = getDateFormat(date) + " Tarihli Sınıf Yoklama Listesi";
      const properties = ["Sınıf"];
      for (let i = 0; i < dailyCourseHour; i++) properties.push((i + 1) + " Ders");

      entities.forEach(entity => {
        const datium = { "Sınıf": entity.section };

        for (let i = 0; i < dailyCourseHour; i++) {
          const status = entity.attendanceStatuses[i].split("\n")[0] + "<br />" + entity.attendanceStatuses[i].split("\n")[1];
          if (status.includes("Alınmadı")) datium[(i + 1) + " Ders"] = "<b>" + status + "</b>";
          else datium[(i + 1) + " Ders"] = status;
        }

        data.push(datium);
      });

      print({ data, properties, header, style : "text-align: center; height: 60px" });
    });
  }

  /** Belli Bir Sınıf Listesine Ait Yoklama Listesini Panoya Kopyalar */
  const copy = () => {
    dispatch(actions.getAllSectionAttendances(sectionsUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const columns = ["Sınıf"];
      for (let i = 0; i < dailyCourseHour; i++) columns.push((i + 1) + ". Ders");

      entities.forEach(entity => {
        const row = [entity.section];
        for (let i = 0; i < dailyCourseHour; i++) row.push(entity.attendanceStatuses[i]);
        rows.push(row);
      });

      const header = getDateFormat(date) + " Tarihli Sınıf Yoklama Listesi";
      copySectionAttendances({ header, columns, rows });
    });
  }

  return (
    <Card>
      <CardHeader title="Sınıf Listesi">
        {
          isExportationAuthorized &&
          <CardHeaderToolbar>
            <ExportButton
              exportToExcel={exportToExcel}
              exportToPDF={exportToPDF}
              print={printSectionAttendances}
              copy={copy}
            />
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <SectionsFilter
          date={date}
        />
        <SectionsTable
          date={date}
        />
      </CardBody>
    </Card>
  );
}